// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3K8tM","right":"styles_right__3Gd1l"};